import {useIntl} from 'react-intl'
import {emailRegex, nameRegex} from './formConstants'

export default function useGiftCertificateFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        receipientName: {
            name: `${prefix}receipientName`,
            label: formatMessage({
                defaultMessage: 'Recipient Name',
                id: 'use_giftCertificate_fields.label.receipientName'
            }),
            type: 'text',
            placeholder: 'Full Name',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'This field is required',
                    id: 'use_giftCertificate_fields.error.required_receipient_name'
                }),
                pattern: {
                    value: nameRegex,
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid receipient name.',
                        id: 'use_giftCertificate_fields.label.valid.receipientName'
                    })
                }
            },
            error: errors[`${prefix}receipientName`],
            control
        },
        receipientEmail: {
            name: `${prefix}receipientEmail`,
            label: formatMessage({
                defaultMessage: 'Recipient Email',
                id: 'use_giftCertificate_fields.label.receipientEmail'
            }),
            placeholder: 'Email Address',
            type: 'email',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'This field is required',
                    id: 'use_giftCertificate_fields.error.required_receipient_email'
                })
            },
            pattern: {
                value: emailRegex,
                message: formatMessage({
                    defaultMessage: 'Please enter a valid receipient email address.',
                    id: 'use_giftCertificate_fields.label.valid.receipientEmail'
                })
            },
            error: errors[`${prefix}receipientEmail`],
            control
        },
        senderName: {
            name: `${prefix}senderName`,
            label: formatMessage({
                defaultMessage: 'Your Name',
                id: 'use_giftCertificate_fields.label.senderName'
            }),
            type: 'text',
            placeholder: 'Full Name',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'This field is required',
                    id: 'use_giftCertificate_fields.error.required_sender_name'
                }),
                pattern: {
                    value: nameRegex,
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid sender name.',
                        id: 'use_giftCertificate_fields.label.valid.senderName'
                    })
                }
            },
            error: errors[`${prefix}senderName`],
            control
        },
        senderEmail: {
            name: `${prefix}senderEmail`,
            label: formatMessage({
                defaultMessage: 'Your Email',
                id: 'use_giftCertificate_fields.label.senderEmail'
            }),
            placeholder: 'Email Address',
            type: 'email',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'This field is required',
                    id: 'use_giftCertificate_fields.error.required_sender_email'
                })
            },
            pattern: {
                value: emailRegex,
                message: formatMessage({
                    defaultMessage: 'Please enter a valid sender email address.',
                    id: 'use_giftCertificate_fields.label.valid.senderEmail'
                })
            },
            error: errors[`${prefix}senderEmail`],
            control
        }
    }

    return fields
}
